/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

// require('./bootstrap');
const hljs = require('highlight.js');
require('highlightjs-copy');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
window.numeral = require( 'numeral');

require('./format');
require('./theme');
require('./product');

require('../commons/bootstrap');
require('../commons/components');
require('../commons/notify');
require('../commons/actions');

// hljs.addPlugin(new CopyButtonPlugin());
hljs.highlightAll();
